import loadImagesFromFilestore from '../lib/loadImagesFromFilestore'

function generateWineProductImagePresets(image) {
  return [
    { ...image, preset: 'wineproductdetails' },
    { ...image, preset: 'wineproductdetails__lowres' },
    { ...image, preset: 'wineproductteaser' },
    { ...image, preset: 'wineproductteaser__lowres' }
  ]
}

function generateFileStoreImageList(products) {
  let imageList = []

  for (let i = 0; i < products.length; i++) {
    if (products[i].node_type === 'wine_product' && products[i].hasOwnProperty('image') && products[i].image !== null) {
      imageList.push(generateWineProductImagePresets((products[i].image)))
    }
  }

  return imageList
}

export default function loadProductImages(products, store) {
  const filestoreImageList = {
    files: generateFileStoreImageList(products)
  }

  return loadImagesFromFilestore(filestoreImageList, store)
}
